import React, { useEffect, useRef, useState } from 'react'
import MessageHeading from '../../components/CommonComponents/MessageHeading'
import MessageBox from '../../components/CommonComponents/MessageBox'
import { useMyContext } from '../../components/Provider/CommonProvider'
import { connect } from 'react-redux'
import AdminCustomSelect from '../../components/CommonComponents/AdminCustomSelect'
import { toast } from 'react-toastify'
import AdminCustomButton from '../../components/CommonComponents/AdminCustomButton'
import AdminCheckBox from '../../components/CommonComponents/AdminCheckBox'
import { IoClose } from 'react-icons/io5'
import { IoIosInformationCircleOutline } from 'react-icons/io'
import AdminCustomInput from '../../components/CommonComponents/AdminCustomInput'
import MessageSubHeading from '../../components/CommonComponents/MessageSubHeading'

const VideoCipherStorage = ({ storageLoading, storageSettingError, storageSetting, siteTheme }) => {
    const { handleFileChangeProvider, fetchRequest } = useMyContext()
    const baseURL = process.env.REACT_APP_Baseurl

    const libraryIndex = `${baseURL}/admin/videoCipher-videoIndex`
    const moveApi = `${baseURL}/admin/videoCipher-UpdateVideoId`
    const uploadApi = `${baseURL}/admin/videoCipher-uploadVideo`
    const titleApi = `${baseURL}/admin/library/search-title`

    const [state, setState] = useState({
        upload_type: "video",
        videoPage: 1,
        videoLimit: 10,
        videoTotalCount: 0,
        allVideos: [],
        withOutRefresh: [],
        videoLoading: true,
        uploadIdLoading: false,
        upload_single: "0",
        videoIds: [],
        videocipher_resolution: "",
        upload_source_type: 18,
        source_type: 1,
        uploaded_type: "video"
    })
    const [modelClose, setModelClose] = useState(false);
    const [stateerror, setStateError] = useState({})

    const combinedRef = useRef({});

    const handleTypeChange = (val) => {
        setState((prev) => ({
            ...prev,
            upload_type: val
        }))
    }

    const closeModal = () => {
        setModelClose(prev => !prev);
    };

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'text') {
            setState((prev) => ({
                ...prev,
                [name]: value,
            }));
            setStateError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === "checkbox") {
            setState((prev) => ({
                ...prev,
                [name]: value
            }));
        }
        if (type === "select-one") {
            setState((prev) => ({
                ...prev,
                [name]: value
            }));
        }

        if (type === "radio") {
            if (name === "upload_single") {
                setState((prev) => ({
                    ...prev,
                    [name]: value
                }));
            }
        }
    };

    const handleRowSelect = (item) => {
        setState((prevState) => {
            const prev = prevState.videoIds;
            const exists = prev.some((entry) => entry.id === item?.id);

            if (exists) {
                // Remove the item from the list
                const updated = prev.filter((entry) => entry.id !== item?.id);
                return { ...prevState, videoIds: updated };
            } else {
                let usedIndices, allIndices, availableIndex, resolution;

                if (siteTheme?.enable_ppv_based_resolution == 1) {
                    if (storageSetting?.videocipher_PPV_Resolution?.length === prev.length) {
                        toast.info("You have already selected videos for all available resolutions.");
                        return { ...prevState };
                    }

                    usedIndices = prev.map((entry) =>
                        storageSetting?.videocipher_PPV_Resolution?.findIndex(
                            (r) => r.label === entry.resolution
                        )
                    );

                    allIndices = [
                        ...Array(storageSetting?.videocipher_PPV_Resolution?.length || 0).keys(),
                    ];

                    availableIndex = allIndices.find((i) => !usedIndices.includes(i));

                    resolution = storageSetting?.videocipher_PPV_Resolution?.[availableIndex]?.label || 'default';
                } else {
                    resolution = state?.videocipher_resolution;
                }

                const updated = [...prev, { id: item?.id, resolution, title: item?.title }];
                return { ...prevState, videoIds: updated };
            }
        });
    };

    const openConfirmPOPUpVideoCipher = () => {
        if (!state?.videoIds?.length) {
            toast.info("Please select videos")
            return
        }
        if (siteTheme?.enable_ppv_based_resolution == 1) {
            setModelClose(true)
        }
        else {
            setState((prev) => ({
                ...prev,
                upload_single: "0"
            }))
            videoCipherMoveURL()
        }
    }
    const videoCipherMoveURL = async () => {
        if (state?.upload_single == null || state?.upload_single == "") {
            toast.info("Choose one option from the checkboxes")
            return
        }
        if (siteTheme?.enable_ppv_based_resolution === 0) {
            if (state?.videocipher_resolution == "" || state?.videocipher_resolution == null) {
                toast.info("Please Choose resolution")
                return
            }
        }
        setState((prev) => ({ ...prev, uploadIdLoading: true }))
        const updatedList = state?.videoIds.map((item) => {
            return {
                title: item?.title,
                original_name: item?.title,
                resolutions: item?.resolution,
                videoCipherId: item?.id
            } || []
        })
        const response = await fetchRequest({
            method: 'POST',
            url: `${moveApi}`,
            params: {},
            data: {
                videos: updatedList,
                upload_source_type: state?.upload_source_type,
                upload_single: state?.upload_single,
                source_type: state?.source_type
            },
        }).then((response) => {
            if (response?.status) {
                toast.success(response.message)
                setState((prev) => ({ ...prev, withOutRefresh: !prev, videoIds: [] }))
                setModelClose(false)
            }
        }).catch((err) => {
            toast.error(err?.response?.data?.message || err?.message || err?.response?.message)
        }).finally(() => {
            setState((prev) => ({ ...prev, uploadIdLoading: false }))
        })
    }

    const fetchVideoCipherVideos = async () => {
        try {
            setState((prev) => ({ ...prev, videoLoading: true }))
            const responseVideoCipherLibrary = await fetchRequest({
                method: 'GET',
                url: `${libraryIndex}`,
                params: { page: state?.videoPage, limit: state?.videoLimit },
                data: {},
            })
            if (responseVideoCipherLibrary?.status) {
                setState((prev) => ({
                    ...prev,
                    videoPage: responseVideoCipherLibrary?.currentPage,
                    videoLimit: responseVideoCipherLibrary?.count,
                    allVideos: responseVideoCipherLibrary?.rows
                }))
            }
        }
        catch (error) {
            setState((prev) => ({
                ...prev,
                videoError: error?.response?.data?.error || error?.response?.data?.message || error.message || error || "Something wrong"
            }))
        }
        finally {
            setState((prev) => ({ ...prev, videoLoading: true }))
        }
    }
    const handleInputSearch = async (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: value
        }));

        if (!value.trim()) {
            setState((prev) => ({
                ...prev,
                title_message: '',
                title_status: false
            }));
            return;
        }

        try {
            // Call the API to check title availability
            const availableTitle = await fetchRequest({
                method: 'POST',
                url: `${titleApi}`,
                params: {},
                data: {
                    unique_title: value
                }
            });

            setState((prev) => ({
                ...prev,
                title_message: availableTitle?.message,
                title_status: availableTitle?.status === true
            }));

        } catch (error) {
            console.error("Error checking title availability:", error);
            setState((prev) => ({
                ...prev,
                title_message: error?.response?.data?.message,
                title_status: false
            }));
        }
    };

    useEffect(async () => {
        if (state?.upload_type == "m3u8_url") {
            fetchVideoCipherVideos()
        }
    }, [storageLoading, state?.upload_type])

    useEffect(() => {
        if (siteTheme?.enable_ppv_based_resolution === 0) {
            setState((prev) => ({
                ...prev,
                upload_single: "0"
            }))
        }
    }, [siteTheme])


    return (
        <>
            {modelClose && <div class={`modal  packageModel fade ${modelClose && 'd-block show'}`} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content  theme-bg-color ">
                        <div className="modal-header theme-border-bottom-secondary">
                            <MessageBox text={`${"Confirmation for video resolution updated"}`} classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button type="button" className='bg-transparent theme-text-color' onClick={() => closeModal()} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                        <div className="modal-body">
                            <MessageBox classname="theme-text-color" text="If you select the same video with different resolutions, Please check  [Update Single]. But if you select different videos with different resolutions, Please check  [Update Multiple]." />
                            <div className='d-flex align-items-center  gap-3 mt-3'>
                                <div className='d-flex align-items-center gap-2'>
                                    <AdminCheckBox id="uploadSingle" name="upload_single" type={"radio"} value={1} checked={state?.upload_single == 1} onChange={handleInput} />
                                    <MessageBox text="Update Single" />
                                </div>
                                <div className='d-flex align-items-center gap-2'>
                                    <AdminCheckBox id="uploadMultiple" name="upload_single" type={"radio"} value={0} checked={state?.upload_single == 0} onChange={handleInput} />
                                    <MessageBox text="Update Multiple" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer  border-0">
                            <button type="button" id="closeModel" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={() => closeModal()} ><MessageBox text="Cancel" /> </button>
                            <AdminCustomButton id="videoCipherProceedButton" className='px-3 py-1 m-0 ' saveMethod={videoCipherMoveURL} saveText={"Proceed"} ></AdminCustomButton>
                        </div>
                    </div>
                </div>
            </div>}

            <div className={`theme-bg-color p-4 rounded-3 mb-3`}>
                <MessageHeading text={`Upload to VideoCipher storage`} padding border />
                <div className='d-flex flex-wrap mb-3 align-items-center justify-content-start gap-3 '>
                    <button
                        id="videoButton"
                        className={` ${state?.upload_type === 'video' ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-3 py-3 px-5`}
                        onClick={() => handleTypeChange('video')}
                    > Upload Video to VideoCipher</button>
                    <button
                        id="m3u8Button"
                        className={` ${state?.upload_type === "m3u8_url" ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-3 py-3 px-5`}
                        onClick={() => handleTypeChange('m3u8_url')}
                    > VideoCipher Id to move Site storage</button>
                </div>

                {(state?.upload_type == "video") ?
                    <>
                        <div className="d-flex align-items-center gap-2 my-4">
                            <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"VideoCipher storage does not support video resolution transcoding. Therefore, videos need to be transcoded to the desired resolution before uploading"} />
                        </div>
                        <div className="d-flex align-items-center gap-2 my-4">
                            <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"The title is required for different resolutions of a single video. In the future, if any resolutions are updated or added, the title will still be needed for identification."} />
                        </div>
                        <AdminCustomInput id="uniqueTitle" type="text" name="unique_title" value={state?.unique_title} onChange={(e) => handleInputSearch(e)} placeHolder={"Enter the title"} ref={(el) => (combinedRef.current.unique_title = el)} error={stateerror?.unique_title} />

                        <span>{state?.title_message}</span>


                        {state?.title_status ?
                            <>

                                {siteTheme?.enable_ppv_based_resolution === 1 ? <div className="my-3">
                                    <div className="d-flex align-items-center gap-2 my-4">
                                        <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"If you select the same video with different resolutions, please check (Update Single)."} />
                                    </div>
                                    <div className="d-flex align-items-center gap-2 my-4">
                                        <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"if you select different videos with different resolutions, please check (Update Multiple)."} />
                                    </div>
                                    <div className='d-flex align-items-center  gap-3 mt-3'>
                                        <div className='d-flex align-items-center gap-2'>
                                            <AdminCheckBox id="uploadSingle" name="upload_single" type={"radio"} value={1} checked={state?.upload_single == 1} onChange={handleInput} />
                                            <MessageBox text="Update Single" />
                                        </div>
                                        <div className='d-flex align-items-center gap-2'>
                                            <AdminCheckBox id="uploadMultiple" name="upload_single" type={"radio"} value={0} checked={state?.upload_single == 0} onChange={handleInput} />
                                            <MessageBox text="Update Multiple" />
                                        </div>
                                    </div>
                                </div> : ""}


                                {state?.upload_single != null ?
                                    <>
                                        {siteTheme?.enable_ppv_based_resolution === 1 ?
                                            <>
                                                <div className="d-flex align-items-center gap-2 my-4">
                                                    <IoIosInformationCircleOutline style={{ width: "20px", height: "20px" }} /><MessageSubHeading noMargin text={"* Please upload the correct resolution videos one by one based on the resolutions listed below"} />
                                                </div>
                                                <div className='d-flex align-items-center my-3'>  {storageSetting?.videocipher_PPV_Resolution?.sort((a, b) => parseInt(a.label) - parseInt(b.label))?.map((item) => <span className={`custom-input-border  px-2 py-1 ${state?.videoIds?.some((entry) => entry?.resolution == item?.label) && "theme-button-bg-color theme-button-text-color"}`}>{item?.label}</span>)}</div>
                                            </>
                                            :
                                            <>
                                                <p className=''>Please select the one  resolution</p>
                                                <AdminCustomSelect id="resolutionSelectInput" name="videocipher_resolution" className="d-block w-25 mt-3" value={state?.videocipher_resolution || 0} onChange={handleInput} ref={(el) => (combinedRef.current.videocipher_resolution = el)} options={storageSetting?.transcoding_resolution} error={stateerror?.videocipher_resolution} defaultOptionName={"Choose an one resolution"} />
                                            </>}

                                        {(state?.videocipher_resolution || siteTheme?.enable_ppv_based_resolution == 1) ?
                                            <div className="customDropWrapper rounded-4 theme-bg-color-secondary">
                                                <div className="dropZoneText d-flex align-items-center justify-content-center">
                                                    <MessageBox text="Drag and drop video files here, or click to select files" classname="theme-text-color" />
                                                </div>
                                                <input type="file" id="videoCipherUploadInput" accept="video/mp4" className="w-100 h-100" multiple onChange={(e) => handleFileChangeProvider(e, `${uploadApi}`, "library", { source_type: state?.source_type, upload_source_type: state?.upload_source_type, uploaded_type: state?.uploaded_type, upload_single: state.upload_single, resolution: state?.videocipher_resolution, title: siteTheme?.enable_ppv_based_resolution == 1 ? state?.unique_title : "", resolutions: storageSetting?.videocipher_PPV_Resolution?.sort((a, b) => parseInt(a.label) - parseInt(b.label)), storage: storageSetting, siteTheme: siteTheme })} />
                                            </div> : ""}
                                    </> : ""}
                            </>
                            : ""}
                    </>
                    : ""}

                {(state?.upload_type == "m3u8_url") ?
                    <>
                        {siteTheme?.enable_ppv_based_resolution === 1 ? <>
                            <p className=''>* Please select the correct resolution videos one by one based on the resolutions listed below</p>
                            <div className='d-flex align-items-center my-3'>  {storageSetting?.videocipher_PPV_Resolution?.sort((a, b) => parseInt(a.label) - parseInt(b.label))?.map((item) => <span className={`custom-input-border  px-2 py-1 ${state?.videoIds?.some((entry) => entry?.resolution == item?.label) && "theme-button-bg-color theme-button-text-color"}`}>{item?.label}</span>)}</div>
                        </>
                            : <>
                                <p className=''>* Please select the one  resolution</p>
                                <AdminCustomSelect id="videoCipherResolutionSelect" name="videocipher_resolution" className="d-block w-25 mt-3" value={state?.videocipher_resolution || 0} onChange={handleInput} options={storageSetting?.transcoding_resolution} error={stateerror?.videocipher_resolution} defaultOptionName={"Choose an one resolution"} />
                            </>}

                        {siteTheme?.enable_ppv_based_resolution === 1}
                        <div className='d-flex align-items-start flex-wrap' >
                            {state?.allVideos?.map((item) => {
                                return <div className="col-12 col-sm-6 col-md-4 col-xl-3 p-3 " key={item?.id}>
                                    <div className="overflow-hidden position-relative">
                                        <img src={item?.posters?.[0]?.posterUrl} className="w-100 table-column-grid-image overflow-hidden mb-2 rounded-3" />
                                        <input
                                            type="checkbox"
                                            id={`videoCipherMoveId`}
                                            checked={state?.videoIds?.some((entry => entry?.id == item?.id))}
                                            onChange={() => handleRowSelect(item)}
                                            className='table-checkbox-list position-absolute'
                                        />
                                        <span>{item?.title}</span>
                                    </div>
                                </div>
                            })}
                        </div>
                        <AdminCustomButton id={"openModalButton"} saveMethod={openConfirmPOPUpVideoCipher} saveText="Move to Site Library" loading={state?.uploadIdLoading} className={"d-flex justify-content-end ms-auto mt-5"} />
                    </>
                    : ""}

            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    storageSetting: state.storageSetting.data,
    storageSettingError: state.storageSetting.error,
    storageLoading: state.storageSetting.loading,
    siteTheme: state.siteTheme.siteTheme
});
export default connect(mapStateToProps)(VideoCipherStorage)